




































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import Enums from '@/lib/enums'
    import storeaddressInfo from '@/store/entities/back-storeaddress-list';
    import DateUtils from '@/common/js/DateUtils'
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    Vue.use(Preview);

    class PagebacklistedhistoryRequest extends PageRequest {
        beginWarehouseIssueTime?: Date;
        endWarehouseIssueTime?: Date;
        logisticsNumber: string;
        storeId?: number;
        productSku: string;
        userCode: string;
        inStockNumber: string;
    }

    @Component({
        name: "backlistedhistory",
    })
    export default class backlistedhistory extends AbpBase {
        editModalShow: boolean = false;
        settingCostModalShow: boolean = false;
        deductModalShow: boolean = false;
        storeaddressList: Array<storeaddressInfo> = [];
        pagerequest: PagebacklistedhistoryRequest = new PagebacklistedhistoryRequest();
        IsCheckedStatus = Enums.getEnum(Enums.IsCheckStatus, true);
        creationTime: Date[] = [];
        isArrived: boolean;
        isPrompt: boolean;
        createModalShow: boolean = false;
        get list() {
            return this.$store.state.backlistedhistory.list;
        };
        get loading() {
            return this.$store.state.backlistedhistory.loading;
        }
        async add() {
            this.createModalShow = true;
        }
        pageChange(page: number) {
            this.$store.commit('backlistedhistory/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('backlistedhistory/setPageSize', pagesize);
            this.getpage();
        }
        async searchPage() {
            this.$store.state.user.currentPage = 1;
            this.getpage();
        }
        async getpage() {

            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            //filters

            if (this.creationTime.length > 0) {
                this.pagerequest.beginWarehouseIssueTime = this.creationTime[0];
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.endWarehouseIssueTime = this.creationTime[1];
            }
            this.getData();
            await this.$store.dispatch({
                type: 'backlistedhistory/getAll',
                data: this.pagerequest
            })

        }

        async operationData(name: any, data: any) {

        }
        async getData() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            var a = new storeaddressInfo();
            a.id = null;
            a.storeName = "全部";
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
            this.storeaddressList.push(a);
        }

  
        get pageSize() {
            return this.$store.state.backlistedhistory.pageSize;
        }
        get totalCount() {
            return this.$store.state.backlistedhistory.totalCount;
        }
        get currentPage() {
            return this.$store.state.backlistedhistory.currentPage;
        }
        columns = [
            {
                title: '入库单号',
                key: 'inStockNumber',
                width: 200,
            },
            {
                title: '备货信息',
                width: 240,
                render: (h: any, params: any) => {
                    var a = "red";
                    return h('div', [h('h3', "国内物流单号:" + (params.row.logisticsNumber == null ? "" : params.row.logisticsNumber)), h('h3', "打包件数:" + (params.row.packageNums == null ? "" : params.row.packageNums))])
                }
            },
            {
                title: '备货入库仓库',
                key: 'storeName',
                width: 150,
            },
            {
                title: '产品图片',
                key: 'productImgGuid',
                width: 95,
                render: (h: any, params: any) => {
                    if (params.row.productImgGuid) {
                        var data = { imageGuid: params.row.productImgGuid, url: null };
                        this.$store.commit('expressuserinfo/getImgUrl', data);
                        var url = data.url;;
                        return h('img', {
                            style: {
                                width: "50px",
                                height: "50px",
                                verticalAlign: "middle"
                            },
                            attrs: {
                                src: url,
                                preview: "yc_" + params.row.id,
                                "preview-text": params.row.orderNumber + "cp"
                            }
                        });

                    } else {
                        return h('span', "");
                    }
                }
            },
            {
                title: '产品信息',
                width: 360,
                render: (h: any, params: any) => {
                    var a = "red";
                    return h('div', [h('h3', "类型:" + Enums.ProductType.filter(function (item) { return item.value == params.row.productType })[0].name), h('h3', "SKU:" + (params.row.productSku)), h('h3', "名称:" + (params.row.productName)), h('h3', "链接:" + (params.row.productLink == null ? "" : params.row.productLink)), h('h3', "数量:" + (params.row.productNums)), h('h3', { style: { color: a } }, "备注：" + (params.row.remark == null ? "" : params.row.remark))])
                }
            },
            //{
            //    title: '产品类型',
            //    width: 90,
            //    key: 'productType',
            //    render: (h: any, params: any) => {
            //        return h('span', Enums.ProductType.filter(function (item) { return item.value == params.row.productType })[0].name);
            //    }
            //    },
         
            {
            title: '头程运费【积分】',
                key: 'headFee',
            width: 150,
            },
            {
                title: '上架费【积分】',
                key: 'shelfCost',
                width: 150,
            },
            {
                title: '货架位置',
                key: 'shelfPosition',
                width: 150,
            },
            {
                title: '时间',
                width: 250,
                render: (h: any, params: any) => {
                    return h('div', [h('h3', "入库单创建:" + (params.row.warehouseStockCreationTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.warehouseStockCreationTime)))), h('h3', "广州仓发出:" + (params.row.warehouseIssueTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.warehouseIssueTime)))), h('h3', "产品上架:" + (params.row.productLaunchTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.productLaunchTime))))])
                }
            },
            //{
            //    title: '扣费详情',
            //    width: 280,
            //    render: (h: any, params: any) => {
            //        return h('div', [h('h3', "开始扣费时间:" + (params.row.beginDeductionTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.beginDeductionTime)))), h('h3', "扣费周期:" + (params.row.deductionCycle == null ? "" : params.row.deductionCycle + "天")), h('h3', "扣除积分/周期:" + (params.row.deductIntegral == null ? "" : params.row.deductIntegral + "积分")), h('h3', "上架费:" + (params.row.shelfCost == null ? "" : params.row.shelfCost + "积分"))])
            //    }
            //},

            //{
            //    title: '打包数量',
            //    key: 'packageNums',
            //    width: 90,
            //},
            //{
            //    title: '商品链接',
            //    key: 'productLink',            //{
            //    title: '开始扣费时间',
            //    key: 'beginDeductionTime',
            //    width: 150,
            //    render: (h: any, params: any) => {
            //        return h('span', params.row.beginDeductionTime == null ? "" :DateUtils.formatLongDate(new Date(params.row.beginDeductionTime)));
            //    }
            //},
            //{
            //    title: '扣费积分',
            //    key: 'deductIntegral',
            //    width: 200,
            //},
            //{
            //    title: '扣费周期/积分',
            //    key: 'deductionCycle',
            //    width: 200,
            //},
            //    width: 200,
            //},
            //{
            //    title: '商品名称',
            //    key: 'productName',
            //    width: 200,
            //},
            //{
            //    title: '商品数量',
            //    key: 'productNums',
            //    width: 200,
            //},
            //{
            //    title: '采购成本',
            //    key: 'purchaseCost',
            //    width: 200,
            //},
            //{
            //    title: '时间',
            //    width: 230,
            //    render: (h: any, params: any) => {
            //        return h('div', [h('h3', "创建时间:" + (params.row.creationTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.creationTime)))), h('h3', "更新时间:" + (params.row.lastModificationTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.lastModificationTime)))), h('h3', "审核时间:" + (params.row.checkTime == null ? "" : DateUtils.formatLongDate(new Date(params.row.checkTime))))])
            //    }
            //},
            //{
            //title: '创建时间',
            //    key: 'creationTime',
            //width: 150,
            //    render: (h: any, params: any) => {
            //        return h('span', DateUtils.formatLongDate(new Date(params.row.creationTime)));
            //}
            //},
            //{
            //    title: '更新时间',
            //    key: 'lastModificationTime',
            //    width: 150,
            //    render: (h: any, params: any) => {
            //        return h('span', params.row.lastModificationTime == null ? "" :DateUtils.formatLongDate(new Date(params.row.lastModificationTime)));
            //    }
            //},
            //{
            //   title: '备注',
            //   width: 220,
            //   key: 'reMark',
            // },
        ]
        async created() {

            this.getpage();
        }
    }
